import React, { FunctionComponent } from 'react'
import { Divider as CoreDivider } from '@afterpaytouch/core'
import styles from './style.module.css'

export const Divider: FunctionComponent = () => {
  return (
    <div className={styles.container}>
      <CoreDivider />
    </div>
  )
}
